export const CARE_TYPE_FILTER_ANY = '__ANY__';

export const CARE_TYPE_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: CARE_TYPE_FILTER_ANY, label: 'Any' },
  { value: 'BABYSITTER', label: 'Babysitter' },
  { value: 'NANNY', label: 'Nanny' },
  { value: 'PET_CARE', label: 'Pet care' },
  { value: 'COMPANION_CARE', label: 'Companion care' },
  { value: 'HOUSEKEEPING', label: 'Housekeeping' },
];

export const ALLOWED_CARE_TYPE_VALUES = new Set(
  CARE_TYPE_FILTER_OPTIONS.filter((o) => o.value !== CARE_TYPE_FILTER_ANY).map((o) => o.value)
);

export const careTypeFilterQueryOptions = {
  toQuery: (v: string): string => v.toLowerCase(),
  fromQuery: (v: string): string | null => {
    const upper = v.toUpperCase();
    return ALLOWED_CARE_TYPE_VALUES.has(upper) ? upper : null;
  },
};

export function careTypeButtonLabelFor(value: string | null): string {
  if (!value) return 'Care type';
  const match = CARE_TYPE_FILTER_OPTIONS.find((o) => o.value === value);
  return match ? match.label : 'Care type';
}
